import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from '@/router'
import theme from './modules/theme'
import session from './modules/session'
import sort from './modules/sort'
import author from './modules/author'
import vimeo from './modules/vimeo'

Vue.use(Vuex, VueAxios, axios);

// const URL_V2 = 'http://eposter-api.entwicklung:8030/api/v2';
const URL_V2 = 'https://' + process.env.VUE_APP_CONGRESS_SHORT + '.eposter.documedias.systems/api/v2';
// const URL_V1 = 'http://eposter-api.entwicklung:8030/api/v1';
const URL_V1 = 'https://' + process.env.VUE_APP_CONGRESS_SHORT + '.eposter.documedias.systems/api/v1';

const congress = process.env.VUE_APP_CONGRESS_DB;


export default new Vuex.Store({
    state: {
        login: {'enabled': false, authenticated: null, error: false},
        videoCheck: false,
        fullscreen: false,
        openCollapse: '',
        posters: [],
        poster: [],
        statistics: {},
        presentationSite: null,
        ratings: [],
        views: [],
        ratingstop5: [],
        loader: false,
        thumbnails: true,
        themes: [],
        selectedTheme: null,
        groups: [],
        selectedGroup: null,
        selectedSession: null,
        selectedType: null,
        selectedView: null,
        selectedSearch: null,
        setting: {
            print: true,
            rating: true,
            comment: true,
            contact: true,
            download: true,
            zoom: true,
            abstract: true,
            pageination: true,
            home_top: true,
            home_views: true,
            nav_session: true,
            nav_theme: true,
            nav_author: true,
            nav_title: true,
            nav_sort: true,
            nav_search: true
        },
        datahelper: {},
        contactPoster: null,
        wording: [],
    },
    actions: {
        GET_ALL_POSTERS: function ({commit}) {
            let url = URL_V2 + '/gallery/poster/list';
            axios.get(url).then((response) => {
                commit('SET_POSTERS', {posters: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_ALL_RATINGS: function ({commit}) {
            let url = URL_V2 + '/gallery/rating/overview';
            axios.get(url).then((response) => {
                commit('SET_RATINGS', {ratings: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_TOP5_RATINGS: function ({commit}) {
            let url = URL_V2 + '/gallery/rating/top/5';
            axios.get(url).then((response) => {
                commit('SET_RATINGSTOP5', {ratings: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_TOP5_VIEWS: function ({commit}) {
            let url = URL_V2 + '/gallery/top/views/5';
            axios.get(url).then((response) => {
                commit('SET_VIEWTOP5', {views: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        getPosterById: function ({commit}, id) {
            return axios.get(URL_V2 + '/gallery/poster/detail/' + id);
        },
        GET_POSTERS: function ({commit, actions}, searchObject) {
            let url = URL_V2 + '/gallery/poster/list';
            url += '?searchvalue=' + searchObject.search;
            axios.get(url).then((response) => {
                commit('SET_SELECTEDSEARCH', {posters: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_STATISTICS: function ({commit}) {
            axios.get(URL_V2 + '/gallery/statistics/overview').then((response) => {
                commit('SET_STATISTICS', {statistics: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_COMMENT: function ({}, id) {
            return axios.get(URL_V2 + '/gallery/comment/' + id);
        },
        CREATE_COMMENT: function ({commit, state, dispatch}, data) {
            return axios.post(URL_V2 + '/gallery/comment', data)
        },
        SET_RATING: function ({commit}, rating) {
            let url = URL_V2 + '/gallery/rating/rate/' + rating.poster_id + '/' + rating.rating;
            axios.post(url).then((response) => {
                commit('SET_RATINGS', {ratings: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        SEND_MAIL_CONTACT: function ({commit}, mail) {
            let url = URL_V2 + '/gallery/mail/contact/' + mail.abstract_id;
            axios.post(url, mail).then((response) => {
            }, (err) => {
                // @todo handle this error
            })
        },
        SEND_LOGIN_CODE: function ({commit}, object) {
            let url = URL_V2 + '/login/code/' + congress;
            axios.post(url, object).then((response) => {
                let error = false;
                if (response.data.authenticated === false || response.data.error === true) {
                    error = true;
                }
                commit('setAuthenticated', {value: response.data.authenticated})
                commit('setAuthError', {value: error})
                if (response.data.authenticated === true) {
                    router.push('/home');
                }
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_DATAHELPER: function ({commit}) {
            let url = 'https://' + process.env.VUE_APP_CONGRESS_SHORT + '.abstract.documedias.systems/api/v1/datahelper/complete';
            axios.get(url).then((response) => {
                commit('setDatahelper', {datahelper: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_THEMES: function ({commit}) {
            let url = URL_V2 + '/gallery/theme/list';
            axios.get(url).then((response) => {
                commit('setThemes', {themes: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        TRACK_ACTION: function ({commit, state, dispatch}, data) {
            return axios.post(URL_V2 + '/gallery/track', data)
        },
        GET_ALL_WORDING: function ({commit}, language) {
            axios.get(URL_V1 + '/wording?language=en', {
                headers: {
                    'locale': 'en',
                }
            }).then((response) => {
                console.log(response.data)
                commit('SET_WORDING', {wording: response.data})
            }, (err) => {
                // @todo handle this error
            })
        },
        GET_SETTING: function ({commit}) {
            axios.get(URL_V1 + '/settings/submission/' + process.env.VUE_APP_SYSTEM_ID, {}).then((response) => {
                commit('SET_SETTING', {setting: response.data.settings})
            }, (err) => {
                // @todo handle this error
            })
        },
    },
    mutations: {
        SET_POSTERS: (state, {posters}) => {
            state.posters = posters;
            state.loader = false;
        },
        SET_SELECTEDSEARCH: (state, {posters}) => {
            state.selectedSearch = posters;
            state.loader = false;
        },
        setPoster: (state, poster) => {
            state.poster = poster
        },
        SET_STATISTICS: (state, {statistics}) => {
            state.statistics = statistics
        },
        SET_RATINGS: (state, {ratings}) => {
            state.ratings = ratings;
        },
        SET_RATINGSTOP5: (state, {ratings}) => {
            state.ratingstop5 = ratings
        },
        SET_VIEWTOP5: (state, {views}) => {
            state.views = views
        },
        setStarRating(state, payload) {
            state.ratings[payload.id].rating = payload.value;
        },
        setAuthenticated(state, status) {
            state.login.authenticated = status.value;
        },
        setAuthError(state, status) {
            state.login.error = status.value;
        },
        setThemes(state, {themes}) {
            state.themes = themes;
        },
        setDatahelper(state, {datahelper}) {
            state.datahelper = datahelper;
        },
        setSelectedTheme(state, theme) {
            state.selectedTheme = theme;
        },
        setSelectedType(state, type) {
            state.selectedType = type;
        },
        setSelectedView(state, view) {
            if (view === 'session' || view === 'theme' || view === 'author' || view === 'title' || view === 'search') {
                state.selectedView = view;
            } else {
                console.log('falscher View');
            }
        },
        setContactPoster(state, poster_id) {
            state.contactPoster = poster_id;
        },
        SET_WORDING: (state, {wording}) => {
            state.wording = wording[0].gallery
        },
        SET_SETTING: (state, {setting}) => {
            state.setting = setting
        },
    },
    getters: {
        poster: state => state.poster,
        filteredPosters(state) {
            state.loader = true;
            let posters = state.posters;
            if (state.selectedType != null) {
                posters = posters.filter(poster => poster.type_id == state.selectedType)
            }
            switch (state.selectedView) {
                case "session":
                    if (state.session.selectedSession > 0) {
                        posters = posters.filter(poster => poster.session_id && poster.session_id.includes(state.session.selectedSession))
                    }
                    break;
                case "theme":
                    if (state.theme.selectedTheme > 0) {
                        posters = posters.filter(poster => poster.theme_id === state.theme.selectedTheme)
                    }
                    break;
                case "author":
                    if (state.author.selectedAuthor.length > 0) {
                        let abstracts = state.author.authorList[state.author.selectedAuthor].abstracts;
                        posters = posters.filter(poster => abstracts.includes(poster.abstract_id));
                    }
                    break;
                case "title":
                    break;
                case "search":
                    if (state.selectedSearch && state.selectedSearch.length > 0) {
                        posters = posters.filter(poster => state.selectedSearch.includes(poster.abstract_id));
                    }
                    break;

            }
            if (sort.state.sortOrder === 'asc') {
                posters = posters.sort(function (a, b) {
                    let x;
                    let y;
                    if (typeof a[state.sort.sortField] === 'string') {
                        x = a[state.sort.sortField].toLowerCase();
                        y = b[state.sort.sortField].toLowerCase();
                    } else {
                        x = a[state.sort.sortField];
                        y = b[state.sort.sortField];
                    }
                    if (x < y) {
                        return -1;
                    }
                    if (x > y) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                posters = posters.sort(function (a, b) {
                    let x;
                    let y;
                    if (typeof a[state.sort.sortField] === 'string') {
                        x = a[state.sort.sortField].toLowerCase();
                        y = b[state.sort.sortField].toLowerCase();
                    } else {
                        x = a[state.sort.sortField];
                        y = b[state.sort.sortField];
                    }
                    if (x < y) {
                        return 1;
                    }
                    if (x > y) {
                        return -1;
                    }
                    return 0;
                });
            }
            state.loader = false;
            return posters;
        }
    },
    modules: {theme, session, sort, author, vimeo}
})
